import { Injectable } from '@angular/core';
import { AuthSession } from '../interfaces';

const SESSION_KEY         = 'metis_auth_session';
const COMPANY_CONTEXT_KEY = 'metis_company_context';

export interface CompanyContext {
  companyId:      string;
  companyName:    string;
  companyLogoUrl: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  // ── Auth session ──────────────────────────────────────────────────────────

  saveSession(session: AuthSession): void {
    const storage = session.rememberMe ? localStorage : sessionStorage;
    storage.setItem(SESSION_KEY, JSON.stringify(session));
  }

  getSession(): AuthSession | null {
    const raw =
      localStorage.getItem(SESSION_KEY) ??
      sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as AuthSession;
    } catch {
      return null;
    }
  }

  clearSession(): void {
    localStorage.removeItem(SESSION_KEY);
    sessionStorage.removeItem(SESSION_KEY);
    this.clearCompanyContext();
  }

  isSessionExpired(session: AuthSession): boolean {
    return Date.now() >= session.expiresAt;
  }

  // ── Company context (superadmin) ──────────────────────────────────────────

  saveCompanyContext(ctx: CompanyContext): void {
    sessionStorage.setItem(COMPANY_CONTEXT_KEY, JSON.stringify(ctx));
  }

  getCompanyContext(): CompanyContext | null {
    const raw = sessionStorage.getItem(COMPANY_CONTEXT_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as CompanyContext;
    } catch {
      return null;
    }
  }

  clearCompanyContext(): void {
    sessionStorage.removeItem(COMPANY_CONTEXT_KEY);
  }
}
